<div class="details-page-wrapper" *ngIf="person != undefined && contactTags != undefined && featureFlagsLoaded">
  <div class="details-scroll-content">
    <dx-validation-group #personValidationGroup>
    <div class="gpd-form-grid">
      <div class="gpd-form-column">
        <div class="gpd-form-card">
          <div class="gpd-form-card-header">
            <app-svg-icon icon="user-multiple" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
            <span class="gpd-form-card-title" i18n="@@personDetails">Person Details</span>
          </div>

          <div class="gpd-form-row">
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@title">Title</label>
              <dx-text-box class="gpd-input" [(value)]="person.title" [readOnly]="!editMode" [maxLength]="50" i18n-placeholder="@@titlePlaceholder" placeholder="e.g. Dr."></dx-text-box>
            </div>
            <div class="gpd-form-field">
              <label class="gpd-form-label gpd-form-required"><span i18n="@@salutation">Salutation</span></label>
              <dx-select-box
                class="gpd-input"
                [readOnly]="!editMode"
                [(value)]="person.salutation"
                [dataSource]="salutations"
                valueExpr="name"
                displayExpr="name"
                i18n-placeholder="@@pleaseSelect"
                placeholder="Please Select"
              >
                <dx-validator>
                  <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                </dx-validator>
              </dx-select-box>
            </div>
          </div>

          <div class="gpd-form-row">
            <div class="gpd-form-field">
              <label class="gpd-form-label gpd-form-required"><span i18n="@@firstname">Firstname</span></label>
              <dx-text-box class="gpd-input" [(value)]="person.firstname" [readOnly]="!editMode" [maxLength]="100" i18n-placeholder="@@firstnamePlaceholder" placeholder="e.g. John">
                <dx-validator>
                  <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>
            <div class="gpd-form-field">
              <label class="gpd-form-label gpd-form-required"><span i18n="@@lastname">Lastname</span></label>
              <dx-text-box class="gpd-input" [(value)]="person.lastname" [readOnly]="!editMode" [maxLength]="100" i18n-placeholder="@@lastnamePlaceholder" placeholder="e.g. Doe">
                <dx-validator>
                  <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>
          </div>

          <div class="gpd-form-row gpd-form-row--half">
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@birthdate">Birthdate</label>
              <dx-date-box
                class="gpd-input"
                [(value)]="person.birthDate"
                displayFormat="dd.MM.yyyy"
                dateSerializationFormat="yyyy-MM-dd"
                type="date"
                [readOnly]="!editMode"
                i18n-placeholder="@@dateFormatHint"
                placeholder="DD.MM.YYYY"
              ></dx-date-box>
            </div>
          </div>
        </div>

        <div class="gpd-form-card">
          <div class="gpd-form-card-header">
            <app-svg-icon icon="location" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
            <span class="gpd-form-card-title" i18n="@@address">Address</span>
          </div>

          <div class="gpd-form-row">
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@address">Address</label>
              <dx-text-box class="gpd-input" [(value)]="person.address" [readOnly]="!editMode" [maxLength]="255" i18n-placeholder="@@addressPlaceholder" placeholder="e.g. Main Street 1"></dx-text-box>
            </div>
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@city">City</label>
              <dx-text-box class="gpd-input" [(value)]="person.city" [readOnly]="!editMode" [maxLength]="50" i18n-placeholder="@@cityPlaceholder" placeholder="e.g. Berlin"></dx-text-box>
            </div>
          </div>

          <div class="gpd-form-row">
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@zipcode">Zipcode</label>
              <dx-text-box class="gpd-input" [(value)]="person.zipcode" [readOnly]="!editMode" [maxLength]="50" i18n-placeholder="@@zipcodePlaceholder" placeholder="e.g. 12345"></dx-text-box>
            </div>
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@country">Country</label>
              <dx-select-box
                class="gpd-input"
                [readOnly]="!editMode"
                [(value)]="person.countryId"
                [dataSource]="countriesByLanguageList"
                (onSelectionChanged)="handleCountryChange(person.countryId)"
                displayExpr="countryName"
                valueExpr="countryId"
                acceptCustomValue="false"
                i18n-placeholder="@@pleaseSelect"
                placeholder="Please Select"
              ></dx-select-box>
            </div>
          </div>
        </div>

        <div class="gpd-form-card">
          <div class="gpd-form-card-header">
            <app-svg-icon icon="contact" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
            <span class="gpd-form-card-title" i18n="@@contactCaps">Contact</span>
          </div>

          <div class="gpd-form-row">
            <div class="gpd-form-field">
              <label class="gpd-form-label gpd-form-required"><span i18n="@@email">Email</span></label>
              <dx-text-box class="gpd-input" [(value)]="person.email" [readOnly]="!editMode" [maxLength]="255" i18n-placeholder="@@emailPlaceholder" placeholder="e.g. name@company.com">
                <dx-validator>
                  <dxi-validation-rule type="required" i18n-message message="required"></dxi-validation-rule>
                  <dxi-validation-rule type="email"></dxi-validation-rule>
                </dx-validator>
              </dx-text-box>
            </div>
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@fax">Fax</label>
              <dx-text-box class="gpd-input" [(value)]="person.fax" [readOnly]="!editMode" [maxLength]="50" i18n-placeholder="@@phonePlaceholder" placeholder="e.g. +49 30 1234567"></dx-text-box>
            </div>
          </div>

          <div class="gpd-form-row">
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@phoneCompany">Phone (Company)</label>
              <dx-text-box class="gpd-input" [(value)]="person.phoneCompany" [readOnly]="!editMode" [maxLength]="50" i18n-placeholder="@@phonePlaceholder" placeholder="e.g. +49 30 1234567"></dx-text-box>
            </div>
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@phonePrivate">Phone (Private)</label>
              <dx-text-box class="gpd-input" [(value)]="person.phonePrivate" [readOnly]="!editMode" [maxLength]="50" i18n-placeholder="@@phonePlaceholder" placeholder="e.g. +49 30 1234567"></dx-text-box>
            </div>
          </div>

          <div class="gpd-form-row gpd-form-row--half">
            <div class="gpd-form-field">
              <label class="gpd-form-label" i18n="@@phoneMobile">Phone (Mobile)</label>
              <dx-text-box class="gpd-input" [(value)]="person.phoneMobile" [readOnly]="!editMode" [maxLength]="50" i18n-placeholder="@@phonePlaceholder" placeholder="e.g. +49 30 1234567"></dx-text-box>
            </div>
          </div>
        </div>

        <div class="gpd-form-card">
          <div class="gpd-form-card-header">
            <app-svg-icon icon="building" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
            <span class="gpd-form-card-title" i18n="@@companies">Companies</span>
          </div>

          <p class="gpd-form-empty-hint" *ngIf="!personCompanies.length" i18n="@@noCompaniesLinked">
            This person is not linked to any company.
          </p>

          <div *ngIf="personCompanies.length" class="person-card-list">
            <div class="person-card" *ngFor="let company of personCompanies">
              <div class="person-card-main">
                <div class="person-card-name-row">
                  <span class="person-card-name" (click)="gotoCompany(company)">{{ company.name }}</span>
                </div>
                <div class="person-card-contact-row">
                  <span class="person-card-contact-item">
                    <app-svg-icon icon="briefcase" [size]="16" color="var(--color-grey-500)"></app-svg-icon>
                    <span *ngIf="company.role">{{ company.role }}</span>
                    <span *ngIf="!company.role" class="person-card-contact-placeholder" i18n="@@noRole">No role</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gpd-form-column gpd-form-column--side">
        <div class="gpd-form-card">
          <div class="gpd-form-card-header">
            <app-svg-icon icon="tag" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
            <span class="gpd-form-card-title" i18n="@@tags">Tags</span>
          </div>

          <!-- The tag-box's own chip rendering is hidden (see .cap-tags-dropdown in the CSS) —
               selected tags show as pills below; this stays purely a control for
               adding/removing tags via its dropdown checklist. DevExtreme only renders its own
               placeholder when the value is genuinely empty, so a static one is layered on top
               instead — always visible, steps aside only while actually focused. -->
          <div class="cap-tags-dropdown-wrapper" *ngIf="editMode">
            <dx-tag-box
              class="gpd-input cap-tags-dropdown"
              [(value)]="person.tags"
              [items]="contactTags"
              displayExpr="title"
              valueExpr="id"
              [showSelectionControls]="true"
              [showDropDownButton]="true"
              applyValueMode="useButtons"
            ></dx-tag-box>
            <span class="cap-tags-placeholder" i18n="@@assignTags">Assign tags</span>
          </div>

          <div class="contact-tag-container" *ngIf="person.tags?.length">
            <gpd-pill
              *ngFor="let tag of person.tags"
              [text]="getTag(tag)"
              backgroundColor="var(--color-secondary)"
              color="var(--color-primary)"
              [removable]="editMode"
              (onRemove)="removeTag(tag)"
            ></gpd-pill>
          </div>

          <p *ngIf="!editMode && !person.tags?.length" class="gpd-form-empty-hint" i18n="@@noContactTagsYet">
            No tags yet.
          </p>
        </div>

        <div class="gpd-form-card">
          <div class="gpd-form-card-header gpd-form-card-header--actions">
            <div class="gpd-form-card-header__label">
              <app-svg-icon icon="solar-panel" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
              <span class="gpd-form-card-title" i18n="@@relatedProjects">Related Projects</span>
            </div>
            <div class="linked-projects-header-actions">
              <app-gpd-button
                type="text"
                i18n-text="@@addToProject"
                text="Add to Project"
                icon="add"
                (onClick)="addProjectModalVisible = true"
                [disabled]="!editMode"
              ></app-gpd-button>
            </div>
          </div>

          <dx-text-box
            *ngIf="projectsListScrollable"
            class="gpd-input linked-projects-search"
            [(value)]="relatedProjectsSearchTerm"
            valueChangeEvent="keyup"
            i18n-placeholder="@@searchProject"
            placeholder="Search project"
            [showClearButton]="true"
          ></dx-text-box>

          <div
            #projectsListEl
            *ngIf="relatedProjects?.length > 0 && filteredRelatedProjects.length > 0"
            class="linked-projects-list"
          >
            <div class="linked-project-row" *ngFor="let data of filteredRelatedProjects">
              <app-contracts-pill
                *ngIf="data.project"
                class="linked-project-name"
                linkType="techProject"
                [content]="data.project"
                [displayString]="data.project.projectName"
                [projectStatus]="data.project.status"
              ></app-contracts-pill>
              <div class="role-cell linked-project-roles">
                <span
                  class="role-pill role-pill--source"
                  *ngFor="let route of sourceRouting(data)"
                  [title]="route.description"
                  (click)="onItemClick(data, route)"
                >
                  <span class="role-pill__text">{{ route.description }}</span>
                </span>
                <span class="role-pill role-pill--custom" *ngIf="data.role" [title]="data.role">
                  <span class="role-pill__text">{{ data.role }}</span>
                  <button
                    type="button"
                    class="role-pill__x"
                    i18n-title="@@delete"
                    title="Delete"
                    (click)="removeManualProjectRole(data); $event.stopPropagation()"
                  >
                    ×
                  </button>
                </span>
              </div>
            </div>
          </div>
          <p *ngIf="relatedProjects?.length > 0 && filteredRelatedProjects.length === 0" class="gpd-form-empty-hint" i18n="@@noProjectsMatchSearch">
            No projects match your search.
          </p>

          <span class="linked-projects-count" *ngIf="relatedProjects?.length > 0" i18n="@@projectsCount">
            {{ relatedProjects.length }} Projects
          </span>

          <p *ngIf="!(relatedProjects?.length > 0)" class="gpd-form-empty-hint" i18n="@@noRelatedProjectsYet">
            No related projects yet.
          </p>

          <app-contact-add-project-modal
            *ngIf="addProjectModalVisible"
            [(visible)]="addProjectModalVisible"
            [contactId]="currentPersonId"
            contactType="person"
            (onSaved)="onProjectAdded()"
          ></app-contact-add-project-modal>

          <app-delete-popup
            [visible]="deleteRoleVisible"
            i18n-title="@@deleteRole"
            title="Delete role"
            [message]="deleteRoleMessage"
            (onConfirm)="onDeleteRoleConfirmed()"
            (onAbort)="onDeleteRoleAborted()"
            (visibleChange)="deleteRoleVisible = $event"
          ></app-delete-popup>
        </div>

        <div class="gpd-form-card" *ngIf="contractsEnabled">
          <div class="gpd-form-card-header">
            <app-svg-icon icon="contracts" [color]="'var(--color-primary)'" [size]="24"></app-svg-icon>
            <span class="gpd-form-card-title" i18n="@@relatedContractsCaps">Related Contracts</span>
          </div>
          <dx-text-box
            *ngIf="contractsListScrollable"
            class="gpd-input linked-projects-search"
            [(value)]="relatedContractsSearchTerm"
            valueChangeEvent="keyup"
            i18n-placeholder="@@searchContract"
            placeholder="Search contract"
            [showClearButton]="true"
          ></dx-text-box>

          <div
            #contractsListEl
            *ngIf="relatedContracts?.length > 0 && filteredRelatedContracts.length > 0"
            class="linked-projects-list"
          >
            <div class="linked-project-row" *ngFor="let data of filteredRelatedContracts">
              <app-contracts-pill
                class="linked-contract-name"
                linkType="contract"
                [content]="{ contractId: data.id, designation: data.designation }"
              ></app-contracts-pill>
            </div>
          </div>
          <p *ngIf="relatedContracts?.length > 0 && filteredRelatedContracts.length === 0" class="gpd-form-empty-hint" i18n="@@noContractsMatchSearch">
            No contracts match your search.
          </p>

          <span class="linked-projects-count" *ngIf="relatedContracts?.length > 0" i18n="@@contractsCount">
            {{ relatedContracts.length }} Contracts
          </span>

          <p *ngIf="!(relatedContracts?.length > 0)" class="gpd-form-empty-hint" i18n="@@noRelatedContractsYet">
            No related contracts yet.
          </p>
        </div>
      </div>
    </div>
    </dx-validation-group>
  </div>

  <app-form-footer>
    <app-gpd-button footerLeft type="danger" i18n-text="@@delete" text="DELETE" icon="delete" (onClick)="confirmDelete()"></app-gpd-button>
    <app-gpd-button
      footerRight
      *ngIf="editMode"
      type="secondary"
      i18n-text="@@cancel"
      text="CANCEL"
      (onClick)="goTo('contacts/persons')"
      icon="cancel"
    ></app-gpd-button>
    <app-gpd-button footerRight *ngIf="editMode" i18n-text="@@save" text="SAVE" icon="check" (onClick)="save($event)"></app-gpd-button>
  </app-form-footer>

  <app-validation-toast #validationToast></app-validation-toast>
</div>

<!-- <app-delete-popup [message]="'Do you want to delete this contact?'" [(visible)]=" showProjectsList"
    (onAbort)="deletePopupVisible = false"></app-delete-popup> -->

<dx-toast
  [visible]="toastVisible"
  [type]="type"
  message="{{message}}"
  position="bottom center"
  width="fit-content"
>
</dx-toast>

<dx-popup
  [(visible)]="showProjectsList"
  [width]="popupWidth"
  [height]="popupHeight"
  [showTitle]="true"
  title="Delete User"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
>
  <div class="confirmation-message">{{ confirmationMessage }}</div>
  <dx-data-grid
    *ngIf="isGridVisible"
    [dataSource]="affectedProjectsList"
    [allowColumnResizing]="true"
    [columnResizingMode]="'widget'"
    [columnAutoWidth]="true"
    [showBorders]="false"
    [scrolling]="{ mode: 'standard', useNative: true }"
    [hoverStateEnabled]="true"
  >
    <dxi-column
      dataField="projectName1"
      caption="Project Name (Left)"
    ></dxi-column>
    <dxi-column
      dataField="projectName2"
      caption="Project Name (Right)"
    ></dxi-column>
  </dx-data-grid>

  <div class="btn-container">
    <dx-button
      i18n-text
      text="CANCEL"
      class="back-button"
      (onClick)="showProjectsList = false"
    ></dx-button>
    <dx-button
      i18n-text
      text="DELETE"
      class="delete-button"
      (onClick)="deletePerson()"
    ></dx-button>
  </div>
</dx-popup>
